import { Box } from '@bechtel/gds';
import { MetadataTableName, PrimaryStatus } from '@bechtel/sr-types';
import { Formik } from 'formik';
import { useEffect, useState } from 'react';
import { TableMetadataContext } from '~/components';
import { usePermissions } from '~/hooks';
import OverridePrimaryStatusForm from './form';
import { OverridePrimaryStatusFormikState, overridePrimaryStatusInitialValues } from './types';

const OverridePrimaryStatus = () => {
  const { canOverridePriStatJtoR } = usePermissions();
  const [initialValues, setInitialValues] = useState<OverridePrimaryStatusFormikState>(
    overridePrimaryStatusInitialValues
  );

  useEffect(() => {
    canOverridePriStatJtoR && setInitialValues({ ...initialValues, oldPrimaryStatus: PrimaryStatus.J });
  }, [canOverridePriStatJtoR, initialValues]);

  return (
    <Box flexGrow={{ sm: ' 1' }} flexDirection={{ sm: 'column' }}>
      <TableMetadataContext metadataTableName={MetadataTableName.CABLE}>
        <Formik
          enableReinitialize={true}
          validateOnChange={true}
          validateOnBlur={true}
          initialValues={initialValues}
          onSubmit={async (values, { setSubmitting }) => {
            setSubmitting(false);
          }}
        >
          <OverridePrimaryStatusForm />
        </Formik>
      </TableMetadataContext>
    </Box>
  );
};

export default OverridePrimaryStatus;
